import React from 'react';
import { CEOCommandCenter } from './pages/CEOCommandCenter';
export function App() {
  return <CEOCommandCenter data-id="element-0" />;
}